import React, { useContext, useEffect, useMemo, useState } from "react";
import { View, Text } from "react-native";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { useNavigate } from "react-router-dom";
import { InputField } from "../../components/InputField";
import { PasswordInput } from "../../components/PasswordInput";
import { Header } from "../../components/Header";
import { colors } from "../../common/styles/colors";
import { CommonScreenCard } from "../../components/CommonScreenCard";
import { AuthContext } from "./SubscriptionNavigation";
import useUniqueDispatch, {
  isData,
  isLoading,
  useSelector,
} from "../../utils/redux-utils";
import { userCheckEmailAction } from "../../store/user/action";
import { RootState } from "../../store/root-reducer";
export const RegisterPage = () => {
  const navigate = useNavigate();

  const userRequest = useSelector((store: RootState) => store.user);

  const { email, setEmail, password, setPassword } = useContext(AuthContext);

  const [repeatPassword, setRepeatPassword] = useState("");

  const match = useMemo(
    () => !!(repeatPassword && password === repeatPassword),
    [password, repeatPassword]
  );

  const disableButton = !(email && repeatPassword && repeatPassword);

  const [checkEmailToken, checkEmailUnique] = useUniqueDispatch(
    userCheckEmailAction.request
  );

  const isDataLoading = isLoading(userRequest, checkEmailToken);
  const isDataLoaded = isData(userRequest, checkEmailToken);

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const mailRegExp = /.+@.+\..+/;
  const passwordRegExp = /^(?=.*[0-9])(?=.*[a-zA-Z]).+$/;

  const checkEmailHandler = () => {
    if (!mailRegExp.test(email)) {
      setEmailError("Invalid Email");
    } else {
      checkEmailUnique([{ email }]);
    }
    if (password !== repeatPassword) {
      setPasswordError("Passwords mismatch");
    } else if (password.length < 8) {
      setPasswordError("Password must be at least eight symbols length");
    } else if (!passwordRegExp.test(password)) {
      setPasswordError("Password must contain numbers and letters");
    }
  };

  useEffect(() => {
    setEmailError("");
  }, [email]);

  useEffect(() => {
    setPasswordError("");
  }, [password, repeatPassword]);

  useEffect(() => {
    if (isDataLoaded) {
      if (!userRequest.data?.data?.free && email) {
        setEmailError("This email is already taken");
      } else if (email && password && !emailError && !passwordError) {
        navigate("../subscription/phone");
      }
    }
  }, [isDataLoaded]);

  return (
    <CommonScreenCard>
      <Header
        onPressLeft={() =>
          navigate("../subscription/welcome", { replace: true })
        }
      />
      <Text style={[fonts.title, { marginBottom: 8 }]}>Welcome customer!</Text>
      <Text style={[fonts.mediumText_regular, { marginBottom: 51 }]}>
        Password should contain password
      </Text>
      <InputField
        value={email}
        containerStyle={{ marginBottom: 8 }}
        onChangeText={setEmail}
        placeholder="Email"
        error={!!emailError}
        errorText={emailError}
      />
      <PasswordInput
        containerStyle={{ marginBottom: 8 }}
        value={password}
        onChangeText={setPassword}
        matchNoText={match}
        error={!!passwordError}
      />
      <PasswordInput
        value={repeatPassword}
        onChangeText={setRepeatPassword}
        placeholder="Repeat password"
        containerStyle={{ height: 108 }}
        match={match}
        error={!!passwordError}
        errorText={passwordError}
      />
      <CommonButton
        style={{ marginBottom: 32 }}
        textStyle={fonts.mediumText_bold}
        title="Next"
        type={disableButton ? "black" : "blackFilled"}
        onPress={() => checkEmailHandler()}
        disabled={disableButton}
        isLoading={isDataLoading}
      />
      <View style={{ flexDirection: "row" }}>
        <Text style={[fonts.mediumText_regular]}>I have an account! </Text>
        <Text
          onPress={() => navigate("../subscription/login")}
          style={[fonts.mediumText_regular, { color: colors.violet }]}
        >
          Log In
        </Text>
      </View>
    </CommonScreenCard>
  );
};
